import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PriceService {
private apiUrl = `${environment.baseUrl}admin/master`;
 constructor(private http: HttpClient, private ws: PostmethodService) { }

   getList(offset:number, pageSize:number, search: string): Observable<any> {
     const token = sessionStorage.getItem("token");
     const headers = new HttpHeaders({
       "Content-Type": "application/json",
       Authorization: `Bearer ${token}`,
     });
     return this.http.get(`${this.apiUrl}/priceMaster?offset=${offset}&limit=${pageSize}&search=${search}`, { headers, observe: 'response' });
   }

}
